import React from 'react';
import Button from '../Button';
import { useNavigate } from 'react-router-dom';

type MainHeaderProps = {
  logo: string;
  onLogin: () => void;
};

const MainHeader: React.FC<MainHeaderProps> = ({ onLogin, logo }) => {
  const navigate = useNavigate();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-3 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 shadow-2xl border-b border-slate-700/50 sm:px-16">
      {/* Logo Section */}
      <div className="flex items-center space-x-3">
        <div className="bg-white p-2 rounded-lg shadow-lg">
          <img
            src={logo}
            alt="Apilogy Logo"
            className="h-8 w-auto cursor-pointer"
            onClick={() => navigate('/')}
            data-testid="header-logo"
          />
        </div>
        <div className="hidden sm:block">
          <h1 className="text-white font-bold text-lg">Admin Portal</h1>
          <p className="text-slate-300 text-xs">Management System</p>
        </div>
      </div>

      {/* Login Button */}
      <Button 
        variant="outline" 
        onClick={onLogin}
        className="bg-white/10 border-white/20 text-white hover:bg-white/20 hover:border-white/30 transition-all duration-200"
      >
        Login
      </Button>
    </nav>
  );
};

export default MainHeader;
